import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ReturnStruct } from '../../structs/return.struct';
import { GetAnpCodigoFiltroRequest } from '../../requests/motor-fiscal/get-anp-codigo-filtro.request';
import { AnpCodigoRequest } from '../../requests/motor-fiscal/anp-codigo.request';
import { AnpNcmRequest } from '../../requests/motor-fiscal/anp-ncm.request';
import { GetAnpCodigoResponse } from '../../responses/motor-fiscal/get-anp-codigo.response';
import { GetAnpNcmResponse } from '../../responses/motor-fiscal/get-anp-ncm.response';

@Injectable({
  providedIn: 'root',
})
export class AnpService extends CommonService {
  constructor(private httpClient: HttpClient) {
    super();
  }

  private readonly apiUrl = `${environment.urlApiMotorFiscal}Anp`;

  // ── Códigos ANP ────────────────────────────────────────────────────────────

  public getCodigos(filtro: GetAnpCodigoFiltroRequest): Observable<GetAnpCodigoResponse> {
    let params = new HttpParams()
      .set('paginaAtual', (filtro.paginaAtual ?? 1).toString())
      .set('tamanhoPagina', (filtro.tamanhoPagina ?? 20).toString());

    if (filtro.pesquisa) params = params.set('pesquisa', filtro.pesquisa);
    if (filtro.idRegimeIcms != null) params = params.set('idRegimeIcms', filtro.idRegimeIcms.toString());
    if (filtro.exigePbio != null) params = params.set('exigePbio', filtro.exigePbio.toString());
    if (filtro.exigeGrupoGlp != null) params = params.set('exigeGrupoGlp', filtro.exigeGrupoGlp.toString());
    if (filtro.isAtivo != null) params = params.set('isAtivo', filtro.isAtivo.toString());

    return this.httpClient
      .get<GetAnpCodigoResponse>(`${this.apiUrl}/codigo`, { ...this.addHeaderToken(), params })
      .pipe(catchError(this.handleError));
  }

  public criarCodigo(request: AnpCodigoRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/codigo`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public alterarCodigo(id: number, request: AnpCodigoRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(`${this.apiUrl}/codigo/${id}`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public excluirCodigo(id: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(`${this.apiUrl}/codigo/${id}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public alterarStatusCodigo(id: number, isAtivo: boolean): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(`${this.apiUrl}/codigo/${id}/status`, { isAtivo }, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  // ── Mapeamento NCM × ANP ─────────────────────────────────────────────────────

  public getNcms(pesquisa: string, isAtivo: boolean | null, paginaAtual = 1, tamanhoPagina = 50): Observable<GetAnpNcmResponse> {
    let params = new HttpParams()
      .set('paginaAtual', paginaAtual.toString())
      .set('tamanhoPagina', tamanhoPagina.toString());
    if (pesquisa) params = params.set('pesquisa', pesquisa);
    if (isAtivo != null) params = params.set('isAtivo', isAtivo.toString());

    return this.httpClient
      .get<GetAnpNcmResponse>(`${this.apiUrl}/ncm`, { ...this.addHeaderToken(), params })
      .pipe(catchError(this.handleError));
  }

  public criarNcm(request: AnpNcmRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/ncm`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public alterarNcm(id: number, request: AnpNcmRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(`${this.apiUrl}/ncm/${id}`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public excluirNcm(id: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(`${this.apiUrl}/ncm/${id}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public alterarStatusNcm(id: number, isAtivo: boolean): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(`${this.apiUrl}/ncm/${id}/status`, { isAtivo }, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
